<template>
	<nav class="side-nav">
		<fragment v-for="btn in btnList" :key="btn.name">
			<button @click="btn.fn" class="btn-sm round" type="button">{{btn.name}} </button>
		</fragment>
		<ul v-if="menus" class="side-nav-menu bar m-t-15">
			<li v-for="(menu, idx) in menus" :key="'sidemenu-menu-'+idx+'-'+hash(menu)">
				<a :class="{'on' : menu.selected}" @click="clickMenu(menu)">{{ menu.name }} <img src="images/view-off.png" alt="노출안함" v-if="menu.hideEnable"/></a>
				<!-- <a :href="menu.link">{{menu.name}}</a> -->
				<template v-if="menu.hasOwnProperty('sub_menus')">
				<ul>
					<li v-for="(sub_menu, idx) in menu.sub_menus" :class="{'on' : sub_menu.selected}" :key="'sidemenu-submenu-'+idx+'-'+hash(sub_menu)">
						<a :class="{'on' : sub_menu.selected}" @click="clickMenu(sub_menu)">
							- {{sub_menu.name}}
						</a>
					</li>
				</ul>
				</template>
			</li>
		</ul>
	</nav>
</template>

<script>
import fnHash from '../mixins/fnHash.js'

export default {
	// 컴포넌트 명
	name: "CommonSideMenu",
	mixins: [fnHash],

	// 이 컴포넌트 내부에서 사용되는 데이터
	data: function() {
		return {

		}
	},

	// 컴포넌트 내부 데이터 변경 감시
	watch: {

	},

	// 부모컴포넌트로부터 전달받는 프로퍼티
	props: {
		menus: Array,
		btnList: Array
	},

	// 이 컴포넌트에서 사용되는 기능
	methods: {
		handleClick() {
			this.$emit('click')
		},
		clickMenu(menu) {
			if(menu.link) this.$router.push(menu.link)
			else if(menu.fn) menu.fn()
			else this.$emit("sidemenuSelected", menu)
		}
	}
}
</script>

<style scoped>
.bottom-nav { overflow: hidden; }
</style>